import { createContext, useContext } from 'react'
import type { DialogProps } from './types'

export const DialogPropsContext = createContext<DialogProps>(
  null as any as DialogProps
)

export const useDialogProps = () => {
  return useContext(DialogPropsContext)
}
